<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        class="mg-r-15"
        label="CRÉER"
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        tooltip="Création d'un environnement point de livraison"
        (onClick)="openEditEnvironnementPlc(undefined)"></yo-button>
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="environnementPlcList"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="id" caption="Actions" [width]="100"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Env. point de livraison" [width]="350"
              [allowFiltering]="true">
  </dxi-column>

  <dxi-column dataField="site" caption="Site" [width]="200" cellTemplate="siteCellTemplate"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="descriptif" caption="Description"
              [width]="350"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="actif" caption="Actif" [width]="80"
              [allowFiltering]="true">
  </dxi-column>

  <!--  ACTIONS CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'siteCellTemplate'">
    <yo-site [siteId]="cell.row.data.site.id" [siteLibelle]="cell.row.data.site.libelle"></yo-site>
  </div>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openEditEnvironnementPlc(cell.row.data)"
                    [iconClass]="canModify(cell.row.data) ? 'fa fa-edit' : 'fa fa-eye'"
                    [tooltip]="(canModify(cell.row.data) ? 'Modifier' : 'Voir') + ' le marché'"
    ></yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" *ngIf="canModify(cell.row.data)"
                    (onClick)="deleteEnvironnementPlc(cell.row.data)"
                    iconClass="fa fa-trash"
                    tooltip="Supprimer le marché"
    ></yo-button>
  </div>
  <dxo-pager
    [showPageSizeSelector]="false"
    [showNavigationButtons]="false"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} Env. Points de livraison">
  </dxo-pager>

</dx-data-grid>
